import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useEffect } from "react";
import { FONTS, PRIMARY_COLOR } from "../../constants";
import { stateType } from "../../state";
import { DistributionBox } from "./DistributionBox";
import { DropZoneBoxx } from "./DropZoneBox";
import { TableBox } from "./TableBox";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../../helpers/pageMeta";
import { ShareBanner } from "../ShareBanner";

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		grid: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
			width: "75vw",
			maxWidth: "1200px",
			alignSelf: "center",
			whiteSpace: "nowrap",
		},
		gridWithMargin: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
			width: "75vw",
			maxWidth: "1200px",
			alignSelf: "center",
			whiteSpace: "nowrap",
			marginBottom: "20px",
		},
		grid2: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "left",
			width: "75vw",
			maxWidth: "1200px",
			alignSelf: "center",
			whiteSpace: "nowrap",
		},
		root: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			width: "100%",
		},
		divider: { width: "20px" },
		divider2: { height: "20px" },
		title: {
			fontSize: "20px",
			fontFamily: FONTS,
			marginBottom: "20px",
			textAlign: "left",
			color: PRIMARY_COLOR,
			width: "100%",
		},
		subTitle: {
			fontSize: "15px",
			fontFamily: FONTS,
			marginBottom: "30px",
			marginTop: "-10px",
			textAlign: "left",
			color: "rgba(0,0,0,0.5)",
			width: "100%",
		},
		title2: {
			fontSize: "20px",
			fontFamily: FONTS,
			marginBottom: "20px",
			marginTop: "30px",
			color: PRIMARY_COLOR,
			width: "100%",
		},
	})
);

export function DataTab({ state }: stateType) {
	let classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Data Upload Page", window.location.pathname);
	}, []);
	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Drop-Zone Box</div>
			</div>
			<div className={classes.grid}>
				<DropZoneBoxx state={state}></DropZoneBoxx>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.title2}>Summary Table</div>
			</div>
			<div className={classes.grid}>
				<TableBox state={state}></TableBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.title2}>
					What your raw data looks like
				</div>
			</div>
			<div className={classes.grid}>
				<DistributionBox state={state}></DistributionBox>
			</div>
			{/* <div className={classes.grid}>
        <LoadingDialog state={state}></LoadingDialog>
      </div> */}
		</div>
	);
}
